import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import heroBg from "@assets/bg/bghero11.jpg";
const seatrcLogo = "/logo/seatrc.svg";

const flags = [
  { code: "bn", name: "Brunei" },
  { code: "kh", name: "Cambodia" },
  { code: "id", name: "Indonesia" },
  { code: "la", name: "Laos" },
  { code: "my", name: "Malaysia" },
  { code: "mm", name: "Myanmar" },
  { code: "ph", name: "Philippines" },
  { code: "sg", name: "Singapore" },
  { code: "th", name: "Thailand" },
  { code: "vn", name: "Vietnam" },
];

export const SectionHero = () => {
  // Fungsi untuk scroll ke section berikutnya
  const scrollToNextSection = () => {
    const nextSection = document.getElementById("date");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Reset scroll saat unmount
  useEffect(() => {
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  return (
    <section
      id="hero"
      className="w-full -mt-20 pt-20 min-h-screen text-black text-center flex flex-col justify-center relative"
      style={{
        backgroundImage: `url(${heroBg})`,
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-t from-gray-800 to-gray-900/10 z-0"></div>

      <div className="relative text-white text-center px-6 z-1 flex flex-col justify-center flex-grow mt-20 md:pb-28 gap-4">
        <div className="flex justify-center items-center">
          <motion.img
            src={seatrcLogo}
            alt="SEATRC Logo"
            className="h-32 md:h-48 lg:h-64 object-contain"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.8,
              delay: 0.2,
              ease: [0.4, 0, 0.2, 1],
            }}
            viewport={{ once: true }}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </div>
        <motion.p
          className="text-2xl lg:text-6xl  font-bold mx-auto text-white"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0.3,
            ease: [0.4, 0, 0.2, 1],
          }}
          viewport={{ once: true }}
        >
          SEATRC
        </motion.p>
        <motion.p
          className="text-lg lg:text-4xl font-normal mx-auto text-white"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0.5,
            ease: [0.4, 0, 0.2, 1],
          }}
          viewport={{ once: true }}
        >
          SOUTHEAST ASIAN TRAIL RUNNING CUP
        </motion.p>

        {/* Flags Section */}
        <motion.div
          className="flex flex-wrap justify-center items-center gap-4 pt-4"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          viewport={{ once: true }}
        >
          {flags.map((flag) => (
            <img
              key={flag.code}
              src={`https://flagcdn.com/w80/${flag.code}.png`}
              srcSet={`https://flagcdn.com/w160/${flag.code}.png 2x`}
              alt={flag.name}
              title={flag.name}
              className="w-10 h-auto md:w-14 rounded shadow-sm hover:scale-110 transition-transform duration-200"
            />
          ))}
        </motion.div>
        {/* End Flags Section */}
      </div>

      {/* Mobile and Desktop: Scroll button */}
      <div className="absolute bottom-8 left-0 w-full flex justify-center z-0">
        <motion.div
          className="cursor-pointer text-white animate-bounce z-0"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
          onClick={scrollToNextSection}
        >
          <FontAwesomeIcon icon={faChevronDown} className="text-4xl" />
        </motion.div>
      </div>
      {/* End Mobile and Desktop: Scroll button */}
    </section>
  );
};
